module.exports = "<div class=\"step-validate\">\n    <pes-edoc-transaction-list (onEdocEvent)=\"onEdocEventHandler($event)\"\n                               [attachments]=\"stepTransactionManager.attachments\"\n                               [optionList]=\"step.edocOptions\"\n                               [style]=\"cardStyle\"\n                               [task]=\"task\"\n                               [transactions]=\"stepTransactionManager.transactions\">\n    </pes-edoc-transaction-list>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/component/step-validate/step-validate.component.html
// module id = wePc
// module chunks = 1